import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { Mail, Phone, MessageCircle, Instagram, Facebook, Linkedin, MapPin } from "lucide-react";
import { WHATSAPP_URL, WHATSAPP_NUMBER, SHOP_URL } from "../lib/i18n";

export function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#334155] text-slate-300 mt-20" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            {/*
            <div className="w-10 h-10 bg-[#0891b2] flex items-center justify-center rounded">
              <span className="font-display text-white text-xl leading-none">M</span>
            </div>
            */}
            <div>
              <div className="font-display text-lg text-white">{t.brand}</div>
              <div className="text-[11px] text-slate-400 uppercase tracking-widest">Commercial Kitchen Solutions</div>
            </div>
          </div>
          <p className="text-slate-400 text-sm leading-relaxed max-w-md">{t.footer.about}</p>
        </div>

        <div>
          <h4 className="text-white text-sm font-semibold mb-4 uppercase tracking-wider">{t.footer.quickLinks}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">{t.nav.about}</Link></li>
            <li><Link to="/projects" className="hover:text-white">{t.nav.projects}</Link></li>
            <li><Link to="/brands" className="hover:text-white">{t.nav.brands}</Link></li>
            <li><Link to="/branches" className="hover:text-white">{t.nav.branches}</Link></li>
            <li><Link to="/blog" className="hover:text-white">{t.nav.blog}</Link></li>
            <li><a href={SHOP_URL} target="_blank" rel="noreferrer" className="text-[#ef4444] hover:text-red-300" data-testid="footer-shop-link">{t.nav.shop} →</a></li>
            <li><Link to="/quote" className="text-[#ef4444] hover:text-red-400">{t.nav.quote} →</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm font-semibold mb-4 uppercase tracking-wider">{t.footer.contact}</h4>
          <ul className="space-y-2.5 text-sm">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#ef4444] shrink-0" /> Near Abu Bakkar Siddique Metro Station, Dubai, UAE</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#ef4444]" /> <span dir="ltr">+971 4-288-2777</span></li>
            <li className="flex items-center gap-2"><MessageCircle className="w-4 h-4 text-green-500" /> <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" dir="ltr" className="hover:text-white">{WHATSAPP_NUMBER}</a></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#ef4444]" /> <a href="mailto:admin@mariotkitchen.com" className="hover:text-white" dir="ltr">admin@mariotkitchen.com</a></li>
          </ul>
          <div className="mt-5 flex gap-2">
            <a href="https://www.instagram.com/mariotuae/" data-testid="social-instagram" className="w-8 h-8 bg-slate-800 hover:bg-[#0891b2] flex items-center justify-center rounded transition-colors"><Instagram className="w-4 h-4" /></a>
            <a href="https://www.facebook.com/mariotuae/" data-testid="social-facebook" className="w-8 h-8 bg-slate-800 hover:bg-[#0891b2] flex items-center justify-center rounded transition-colors"><Facebook className="w-4 h-4" /></a>
            <a href="https://www.linkedin.com/company/mariot-kitchen-equipment" data-testid="social-linkedin" className="w-8 h-8 bg-slate-800 hover:bg-[#0891b2] flex items-center justify-center rounded transition-colors"><Linkedin className="w-4 h-4" /></a>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-800 py-5 text-center text-xs text-slate-500">
        © {year} {t.brand}. {t.footer.rights}
      </div>
    </footer>
  );
}
